/**
 * 上传文件 ,上传完显示文件类型图标
 * Author: FJJ
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/08/25.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 * @param onChange          回调数据
 * @param accept            可选接受类型：格式 '.pdf, .jpg, .jpeg, .png',
 * @param flagLimitType     是否限制为当时已有数据类型,默认False,为Ture时，若当时有文件列表数据，即只接受当前文件列表数据的类型
 *
 *  辅助参数
 *  @param maxCount 最大上传数，默认1
 * */
import React from 'react';
import { message, Spin} from 'antd';
import { fexWebUploaderConfig } from "@config/upload";
import {renderFileType} from "./file.util";
import {isEmpty,trim,getFileSuffix} from '@utils/utils';
import "./index.less";

const WebUploader = window.WebUploader;

export default class UploadFileIconComponent extends React.Component {
    static defaultProps = {
        accept:'*',
        flagLimitType:false,
        multiple:true,
        initValue:[],
        maxCount:1,
        styleUpload:'',
        fileSizeLimit: 5*1024*1024,
        topTips:"",// 上传框头部提示内容
        typeUpload:"",// display ： 陈列橱窗模式（显示maxCount个上传框）

    };
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            fileList:props.initValue,
            accept: props.accept,
            flagLimitType: props.flagLimitType,
            loading: false,
        };
    }
    init(successFn) {
        const fileConfig = {
            ...fexWebUploaderConfig,
            accept:this.props.accept,
            fileSingleSizeLimit:this.props.fileSizeLimit,
            auto: true,
        }
        this.uploader = WebUploader.create( fileConfig );
        this.uploader.onUploadSuccess = function (file, response) {
            successFn && successFn(file, response);
        };
        this.uploader.onError = function (file, response) {
            successFn && successFn(file, response);
        };
        this.uploader.on('uploadError', (file,response)=> {
            // message.warning(Lang({id:"ShangChuanShiBai2",default:"上传失败"}));
            successFn && successFn(file, {success:false,data:response});
        });
    }
    /****
     * 通用检查类型
     * 格式 可能是 jpg || .jpg
     * **/
    checkType(resoureType=''){
        let sType = '';
        if(resoureType.indexOf('xls')> -1||resoureType.indexOf('xls')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('pdf')> -1||resoureType.indexOf('PDF')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('doc')> -1||resoureType.indexOf('DOC')> -1){
            sType = 'document';
        }else if(resoureType.indexOf('png')> -1||resoureType.indexOf('PNG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('gif')> -1||resoureType.indexOf('GIF')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpg')> -1||resoureType.indexOf('JPG')> -1) {
            sType = 'pic';
        }else if(resoureType.indexOf('jpeg')> -1||resoureType.indexOf('JPEG')> -1) {
            sType = 'pic';
        }
        else if(resoureType.indexOf('mp4')> -1||resoureType.indexOf('flv')> -1) {
            sType = 'video';
        }
        return sType;
    }

    /**
     * 灵活修改 当前可接受的文件类型
     **/
    setAccept(file){
        const { accept, flagLimitType } = this.state;
        if(flagLimitType){
            let limitAccept = accept;
            const sFileUrl = file.fileUrl||'';
            const sSuffix = getFileSuffix(sFileUrl);
            const sType = this.checkType(sSuffix);
            const acceptlist = limitAccept.split(',');
            let sNewAccpt = '';
            acceptlist.forEach(typeAcc=>{
               const currType =  this.checkType(typeAcc);
               if(currType==sType) sNewAccpt += typeAcc+',';
            })
            this.setState({
                accept:sNewAccpt,
            })
        }
    }
    fileRemove(inx,file){
        const { typeUpload } = this.props;
        const { fileList } = this.state;
        let newFileList = [ ...fileList];
        if(typeUpload=="display"){
            newFileList[inx] = {};
            const tureList = newFileList.filter((item={})=>item.fileId);
            this.props.onChange(tureList);
        }else {
            newFileList.splice(inx,1);
            this.props.onChange(newFileList);
        }
        this.setState({
            // accept:newAccept,
            fileList: newFileList,
        });
    }
    /**
     * 预览
     * */
    handleCancel = () => this.setState({ previewVisible: false });
    /**
     * render list
     * */
    renderList(list=[],accept='*'){
        let child = []
        list.forEach((item,inx)=>child.push(this.renderOne(item,inx,accept)))
        return child;
    }
    renderOne(item,inx,accept){
        return (<div className={"ant-upload-list-picture-card-container"} key={"uf_"+inx}>
            <div className={"ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card"}>
                <div className="ant-upload-list-item-info">
                                <span>
                                    <a
                                        className="ant-upload-list-item-thumbnail"
                                        target="_blank" rel="noopener noreferrer">
                                    {item.fileUrl?renderFileType(item.fileUrl):null}
                                        {/*<img*/}
                                        {/*src={item.fileUrl} className="ant-upload-list-item-image" />*/}
                                    </a>
                                </span>
                </div>
                <span className="ant-upload-list-item-actions">
                                    <label className="ri-edit-box-line color-white cursor-p">
                                      <input type="file" style={{ display: 'none' }} onChange={(e)=>this.upload(e,inx)} accept={accept} />
                                    </label>
                    {item.fileUrl&&<a className={'action ml_6 '}
                                      href={item.fileUrl}
                                      target={"_blank"}
                    ><i className="ri-eye-line color-white"></i></a>}
                    <span className={'action ml_6 cursor-p'} onClick={()=>this.fileRemove(inx)}><i className="ri-delete-bin-6-line color-white"></i></span>
                            </span>

            </div>

            {item.fileName&&<div className={"black45 ellipsis font_12 mt_4"} title={item.fileName}>{item.fileName}</div>}
        </div>)
    }
    // 上传
    upload(e,inx){
        if(e&&e.target&&e.target.files&&e.target.files[0]){
            const arrFileList = e.target.files;
            if(this.props.maxCount>1&&isEmpty(inx)){
                // let flag = true
                let pushList = [], canPushCount =this.props.maxCount-this.state.fileList.length;
                for(let item of arrFileList){
                    if(canPushCount >0 ){
                        const  flag = this.beforeUpload(item,arrFileList);
                        if(flag){
                            pushList.push(item);
                            canPushCount -= 1
                        }
                    } else break
                }

                if(pushList&&pushList.length>0){
                    this.loading(true);
                    this.uploader.addFile(pushList);
                    this.setState({
                        loadInx: "",//多选 的必为新增的
                    })
                }

            }else {
                //  只能传一个或者 编辑情况下
                const flag = this.beforeUpload(arrFileList[0],arrFileList)
                if(flag){
                    this.loading(true);
                    this.uploader.addFile(e.target.files[0]);
                    this.setState({
                        loadInx: inx
                    })
                }
            }
        }
    }
    formatBytes(bytes,decimals) {
        if(bytes == 0) return '0 Byte';
        const k = 1024;
        const dm = decimals + 1 || 3;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    // 上传前置
    beforeUpload(file, files=[]){
        const { flagLimitType,accept,fileList=[] } = this.state;
        const { fileSizeLimit } = this.props;
        if(file.size>fileSizeLimit){
            message.warning(__getServerLanguage('ZongWenJianDaXiaoChaoChuXianZhi', this.formatBytes(fileSizeLimit)));
            return false;
        }
        if(accept){
            const sSuffix = getFileSuffix(file.name);
            const inx = accept.indexOf(sSuffix);
            if(inx<0){
                // 文件格式不正确，不能上传
                message.warning(__getServerLanguage("WenJianGeShiBuZhengQue"))
                return false;
            }
        }
        if(flagLimitType){ // 检查是不在可检查类型中
            if((files.length>1||fileList.length>0)){ // 如果限制类型，同一队列中有不同类型默认不可同时上传
                let type = '';
                // 检查 是否匹配准备上传队列 结束后 type必有值
                for(let key of files) {
                    const currType = this.checkType(getFileSuffix(key.name));
                    if (!isEmpty(type) && type !== currType) {
                        return false
                    }else type = currType;
                }
                // 检查 是否匹配已有列表
                for(let oldFile of fileList) {
                    const currType = this.checkType(oldFile.name);
                    if (type !== currType) {
                        return false
                    }
                }
            }
        }
        return true
    }
    /**
     * 上传成功回调
     * */
    uploadSuccess(respModel){
        const sType = this.checkType(respModel.extend);
        const { maxCount } = this.props;
        const { loadInx,fileList=[] } = this.state;
        const newFile = {
            uid:respModel.id,
            name:respModel.realName+'.'+respModel.extend,
            fileName:respModel.realName+'.'+respModel.extend, // 对接后端保存时用此字段
            extend:respModel.extend,
            fileExtend:respModel.extend,
            fileId:respModel.id,
            fileUrl:respModel.url,
            type: sType,
            status: 'done',
        };
        if(maxCount==1){ // 如果最大上传数为1即更新列队为此上传文件
            const newFileList = [newFile];
            this.props.onChange(newFileList);
            this.setState({
                fileList:newFileList,
            });
        }else {
            let newFileList = [ ...fileList];
            if(newFileList.length==0){
                this.setAccept(newFile); // 如果原文件列表为0才去判断是否限制文件类型
            }
            if(!isEmpty(loadInx)){
                newFileList[loadInx] = newFile;
                this.setState({
                    fileList: newFileList,
                    loadInx:''
                });
            }else {
                newFileList.push(newFile)
                this.setState({
                    fileList: newFileList,
                });
            }
            const tureList = newFileList.filter(item=>item.fileId);
            this.props.onChange(tureList);
        }
    }
    /**
     * 上传 框
     * */
    renderUploadBox(accept='*',tips='',inx=""){
        return (<div className={"ant-upload-list-picture-card-container"}>
            <div className={"ant-upload ant-upload-select ant-upload-select-picture-card"}>
                <label tabIndex="0" className="ant-upload" role="button">
                    <input type="file" style={{ display: 'none' }} onClick={(event={})=>{
                        if(event.target) event.target.value = "";
                    }} onChange={(e)=>this.upload(e,inx)} accept={accept} multiple={this.props.maxCount>1} />
                    <div>
                        <i className="ri-add-line black89 font_18"></i>
                        {/*<div className="ant-upload-text">Upload</div>*/}
                    </div>
                </label>
            </div>
            {tips&&<p>{tips}</p>}
        </div>)
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /*
     * 陈列模式的处理
     * */
    renderDisplay(fileList=[],accept){
        let child = []
        fileList.forEach((item={},inx)=>{
            if(item.fileId){
                child.push(this.renderOne(item,inx,accept))
            }else child.push(this.renderUploadBox(accept,"",inx))
        })
        return child;
    }
    componentWillMount() {
    }
    componentDidMount() {
        if(typeof WebUploader!='undefined'){
            const that = this;
            this.init(function (file, response={}) {
                that.loading(false);
                const {success,valid,model} = response;
                // console.log("回调",response)
                if(success&&valid){
                    that.uploadSuccess(model)
                }else {
                    message.warning(__getServerLanguage("ShangChuanShiBai"));
                }
            });
            const { maxCount, typeUpload } = this.props;
            const { fileList,  } = this.state;
            if(typeUpload=="display"){
                const canUpload = maxCount - fileList.length;
                if(canUpload>0){
                    const newList = new Array(canUpload).fill({fileId:""});
                    const newFiles = [...fileList,...newList];
                    this.setState({
                        fileList: newFiles
                    })
                }
            }
        }
    }

    render() {
        const { maxCount, topTips,typeUpload } = this.props;
        const { fileList, accept, loading } = this.state;
        return (<Spin spinning={loading}>
            {topTips}
           {typeUpload=="display"?<div className={"ant-upload-picture-card-wrapper"}>
               {/* 陈列模式*/}
               <div className={"ant-upload-list ant-upload-list-picture-card flex-item"}>
                   {fileList.length>0&&this.renderDisplay(fileList,accept)}
               </div>
           </div>:<div className={"ant-upload-picture-card-wrapper"}>
                <div className={"ant-upload-list ant-upload-list-picture-card flex-item"}>
                    {fileList.length>0&&this.renderList(fileList,accept)}
                    {fileList.length<maxCount&&this.renderUploadBox(accept)}
                </div>
            </div>}
        </Spin>);
    }
}